import { getCookie } from 'cookies-next';

import { COOKIES } from '@/shared/constants/cookies';

export const isInMobileApp = () => Boolean(getCookie(COOKIES.IN_MOBILE_APP));
